import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';

export const boxMetricsApi = createApi({
    reducerPath: 'boxMetricsApi',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getBoxMetric: builder.query({
            query: ({ data }) => ({
                url: '/box_metrics/get_box_metric',
                method: 'POST',
                body: { 'data': data }
            }),
        })
    }),
});

export const {
    useGetBoxMetricQuery
} = boxMetricsApi;

export default boxMetricsApi.reducer;
